import React, {useEffect, useState} from 'react'
import {getByIdResource, getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileItSkillForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [itSkills, setItSkills] = useState([])
    const [showSecondField, setShowSecondField] = useState(false)

    const [knowledgeLevels, setKnowledgeLevels] = useState([])
    const [showError, setShowError] = useState(false)
    const [showSecondFieldError, setShowSecondFieldError] = useState(false)
    const [showLevelError, setShowLevelError] = useState(false)

    useEffect (() => {
        setEntity(entityTemp)
        if(entityTemp.candidate) {
            getByIdResource('it_skills/get_by_candidate', entityTemp.candidate.id).then((data) => {
                console.log(data.data)
                setItSkills(data.data)
            })
            getResource('language_knowledge_levels').then((data) => {
                console.log(data.data)
                setKnowledgeLevels(data.data)
            })
        }
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-lg-10 offset-lg-1">
                            {(itSkills && itSkills.length > 0) &&
                                (
                                    <Combo
                                        placeholder="Компјутерски вештини"
                                        tooltipText="Одберете компјутерска вештина"
                                        comboClass="combo-form"
                                        onChange={(e) => {
                                            setShowSecondField(false)
                                            setShowError(false)
                                            let chosenSkill = {};
                                            chosenSkill.id = e.target.value;
                                            setEntity({ ...entity, itSkill: chosenSkill })
                                            let el = itSkills.find(el => el.id.toString() === chosenSkill.id.toString());
                                            setShowSecondField(el.other)
                                        }}
                                        onClear={() => setEntity({...entity, itSkill:null})}
                                        array={itSkills}/>)}

                            {showError && <b>Ве молиме одберете компјутерска вештина</b>}


                            {showSecondField &&  <input className="input-form w-100" type="text" required={true}
                                                        placeholder="Внесете компјутерска вештина"
                                                        value={entity.otherItSkill}
                                                        onChange={(e) => {
                                                            setEntity({...entity, otherItSkill: e.target.value})
                                                            setShowSecondFieldError(false)
                                                        }}
                            />}
                            {showSecondFieldError && <b>Ве молиме внесете компјутерска вештина</b>}

                </div>

                        <div className="col-lg-10 offset-lg-1">
                            {(knowledgeLevels && knowledgeLevels.length > 0) &&
                                <Combo
                                    placeholder="Ниво на познавање"
                                    tooltipText="Одберете ниво на познавање на вештина"
                                    comboClass="combo-form"
                                    onChange={(e) => {
                                        let chosenLevel = {};
                                        chosenLevel.id = e.target.value;
                                        setEntity({ ...entity, itKnowledgeLevel: chosenLevel})
                                        setShowLevelError(false)
                                    }}
                                    onClear={() => setEntity({...entity, itKnowledgeLevel:null})}
                                    array={knowledgeLevels}/>}

                            {showLevelError && <b>Ве молиме одберете ниво на познавање</b>}
                        </div>
                        <div className="col-lg-10 offset-lg-1 d-flex justify-content-between">
                            <div
                                className="btn-form"
                                onClick={()=>
                                {setAddEntity(false)
                                    setEntityTemp({candidate: entity.candidate})
                                }}
                            >Затвори</div>
                            <div
                                className="btn-form"
                                onClick={(e) => {
                                    if(((showSecondField === true && entity.otherItSkill !== "") || showSecondField === false)
                                        && (entity.itSkill && entity.itSkill.id !== "0") &&
                                        (entity.itKnowledgeLevel && entity.itKnowledgeLevel.id !== "0")) {
                                        updateResource('candidate_it_skills', entity)
                                            .then((data) => {
                                                console.log(data.data)
                                                setAddEntity(false)
                                                setEntityTemp({candidate: entity.candidate})
                                                setUpdateEntity(!updateEntity)
                                                setShowError(false)
                                                setShowLevelError(false)
                                            })
                                    } else if(!entity.itSkill || entity.itSkill.id === "0"){
                                        setShowError(true)
                                    } else if(showSecondField === true && (!entity.otherItSkill || entity.otherItSkill === "")){
                                        setShowSecondFieldError(true)
                                    } else if (!entity.itKnowledgeLevel || entity.itKnowledgeLevel.id === "0") {
                                        setShowLevelError(true)
                                    }
                                }}
                            >Зачувај</div>
                        </div>
            </>
            )
                }
        </div>
    )
}